import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Container, Header, Segment, Form, Button, Modal, Table, Icon, Message } from 'semantic-ui-react';
import { hideLoading, addProductPricing, getProductPricing, getProductOptions, updatePricingTable } from '../actions';
import _ from 'lodash';

class Brochure extends Component {
  constructor(props) {
    super(props);
    this.state = {
      product_name: 'Brochure',
      variants: [],
      showAddModal: false,
      showErrorMessage: false,
      selectedMaterial: '',
      selectedSize: '',
      materialOptions: [],
      sizeOptions: []
    }
    document.title = `U-Tech Admin - ${this.state.product_name} ${props.offline ? '(Offline)' : ''}`
    this.props.getProductOptions(this.state.product_name);
    this.props.getProductPricing(this.state.product_name, this.props.offline);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.product.options !== nextProps.product.options) {
      this.setState({
        materialOptions: nextProps.product.options.material.values.map((item) => ({ key: item, text: item, value: item })),
        sizeOptions: nextProps.product.options.size.values.map((item) => ({ key: item.type, text: item.type, value: item.type }))
      });
      this.props.hideLoading();
    } else if (this.props.product.pricing !== nextProps.product.pricing) {
      console.log('Pricing changed!');
      console.log(nextProps.product.pricing);
      if (nextProps.product.pricing.length > 0) {
        let variants = JSON.parse(JSON.stringify(nextProps.product.pricing[0].variants));
        console.log(variants);
        this.setState({ variants: variants.map(variant => Object.assign({ new: { quantity: '', '4C_(Both)': '' } }, variant)), showAddModal: false });
        this.props.hideLoading();
      }
    }
  }

  handleAddVariantOpen(e) {
    this.setState({ showAddModal: !this.state.showAddModal });
  }

  handleAddVariantConfirm(e) {
    const { product_name, variants, selectedMaterial, selectedSize } = this.state;

    if (variants.findIndex((el) => ((el.material === selectedMaterial)) && (el.size === selectedSize)) === -1) {
      this.props.addProductPricing({
        name: product_name,
        material: selectedMaterial,
        size: selectedSize,
        prices: [],
        duration: 0
      }, this.props.offline);
    } else {
      console.log('Variant existed!');
      this.setState({ showErrorMessage: true });
    }
  }

  handleDismissErrorMessage(e) {
    this.setState({ showErrorMessage: false });
  }

  handleInputChange = (e, { name, value }) => {
    this.setState({ [name]: value });
  }

  handleEditClicked(id, e) {
    console.log(id);

    let newArr = this.state.variants;
    let index = newArr.findIndex((el) => el.id === id);
    newArr[index].edit = !newArr[index].edit;
    if (!newArr[index].edit) {
      let variants = JSON.parse(JSON.stringify(this.props.product.pricing[0].variants));
      this.setState({ variants: variants.map(variant => Object.assign({ new: { quantity: 0, '4C_(Both)': 0.0 } }, variant)) });
    } else {
      this.setState({ variants: newArr });
    }
  }

  handleExpandClicked(id, e) {
    e.preventDefault();
    e.stopPropagation();
    let newArr = this.state.variants;
    let index = newArr.findIndex((el) => el.id === id);
    newArr[index].expand = !newArr[index].expand;
    this.setState({ variants: newArr });
  }

  handleSaveClicked(id, e) {
    console.log(id);

    let newArr = this.state.variants;
    let index = newArr.findIndex((el) => el.id === id);
    if (newArr[index].edit) {
      if ((newArr[index].new['quantity'] != 0) || (newArr[index].new['4C_(Both)'] != 0.0)) {
        let newObj = {
          quantity: parseInt(newArr[index].new['quantity']),
          '4C_(Both)': parseFloat(newArr[index].new['4C_(Both)'])
        };
        if (newArr[index].prices.findIndex(el => (el.quantity === newObj.quantity)) === -1) {
          newArr[index].prices.push(newObj);
          newArr[index].new['quantity'] = 0;
          newArr[index].new['4C_(Both)'] = 0.0;
          newArr[index].error = false;
          newArr[index].edit = false;
          newArr[index].add = false;
          console.log(newArr[index].prices);
          this.props.updatePricingTable({ id: id, updates: { prices: newArr[index].prices, duration: newArr[index].duration } }, this.props.offline);
        } else {
          newArr[index].error = true;
        }
      } else {
        newArr[index].edit = false;
        newArr[index].add = false;
        newArr[index].error = false;
        console.log(newArr[index].prices);
        this.props.updatePricingTable({ id: id, updates: { prices: newArr[index].prices, duration: newArr[index].duration } }, this.props.offline);
      }
      this.setState({ variants: newArr });
    }
  }

  handleRowDelete(id, index, e) {
    console.log(id + ' ' + index);

    let newArr = this.state.variants;
    let i = newArr.findIndex((el) => el.id === id);
    if (newArr[i].edit) {
      newArr[i].prices.splice(index, 1);
      this.setState({ variants: newArr });
    }
  }

  handleTableInputChange(id, index, e) {
    let newArr = this.state.variants;
    let i = newArr.findIndex((el) => el.id === id);
    if (newArr[i].edit) {
      if (index === -1) {
        newArr[i].new[e.target.name] = e.target.value;
      } else {
        newArr[i].prices[index][e.target.name] = e.target.value;
      }
      this.setState({ variants: newArr });
    }
  }

  handleDurationInputChange(id, e) {
    let newArr = this.state.variants;
    let i = newArr.findIndex((el) => el.id === id);
    if (newArr[i].edit) {
      newArr[i].duration = e.target.value;
      this.setState({ variants: newArr });
    }
  }

  handleResetRow(id, e) {
    let newArr = this.state.variants;
    let i = newArr.findIndex((el) => el.id === id);
    if (newArr[i].edit) {
      newArr[i].new['quantity'] = '';
      newArr[i].new['4C_(Both)'] = '';
      newArr[i].error = false;
      this.setState({ variants: newArr });
    }
  }

  handleAddRow(id, e) {
    let newArr = this.state.variants;
    let i = newArr.findIndex((el) => el.id === id);
    if (newArr[i].add) {
      if (newArr[i].new['quantity'].match(/^(\d*\.)?\d+$/) &&
        newArr[i].new['4C_(Both)'].match(/^(\d*\.)?\d+$/)) {

        let newObj = {
          quantity: parseInt(newArr[i].new['quantity']),
          '4C_(Both)': parseFloat(newArr[i].new['4C_(Both)'])
        };

        if (newArr[i].prices.findIndex(el => (el.quantity === newObj.quantity)) === -1) {
          newArr[i].prices.push(newObj);
          newArr[i].new['quantity'] = '';
          newArr[i].new['4C_(Both)'] = '';
        } else {
          newArr[i].error = true;
        }
        this.setState({ variants: newArr });
      }
    } else {
      newArr[i].new['quantity'] = '';
      newArr[i].new['4C_(Both)'] = '';
      newArr[i].add = true;
      this.setState({ variants: newArr });
    }
  }

  render() {
    const { product_name, showAddModal, showErrorMessage, selectedMaterial, selectedSize, materialOptions, sizeOptions } = this.state;
    const { options } = this.props.product;

    let variants = _.orderBy(this.state.variants, ['size', 'material'], ['asc', 'asc']);

    return (
      <Container>
        <Modal size='small' open={showAddModal}>
          <Modal.Header>Add New Variant</Modal.Header>
          <Modal.Content>
            <Modal.Description>
              <Form>
                <Form.Group widths='equal'>
                  <Form.Select fluid label='Size' options={sizeOptions} placeholder='Size' name='selectedSize' value={selectedSize} onChange={this.handleInputChange} />
                  <Form.Select fluid label='Material' options={materialOptions} placeholder='Material' name='selectedMaterial' value={selectedMaterial} onChange={this.handleInputChange} />
                </Form.Group>
              </Form>
              {showErrorMessage &&
                <Message negative onDismiss={this.handleDismissErrorMessage.bind(this)} content='Product variant existed!' />
              }
            </Modal.Description>
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={this.handleAddVariantOpen.bind(this)}>Cancel</Button>
            <Button onClick={this.handleAddVariantConfirm.bind(this)} positive disabled={(selectedMaterial.length * selectedSize.length) === 0}>Add</Button>
          </Modal.Actions>
        </Modal>
        <Header as="h2">{product_name} <Button color='primary' floated='right' onClick={this.handleAddVariantOpen.bind(this)}>ADD</Button></Header>
        {(variants.length > 0) && (variants.map((variant, index) =>
          <Segment.Group raised key={index}>
            <Segment>
              <Header as="h3" textAlign="center" onClick={this.handleExpandClicked.bind(this, variant.id)}>{variant.size + ' - ' + variant.material}<Icon name={variant.expand ? 'angle up' : 'angle down'} style={{ float: 'right' }} /></Header>
              {(variant.expand) ?
                <Form>
                  <Table compact celled selectable={variant.edit}>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>Quantity</Table.HeaderCell>
                        <Table.HeaderCell>4 Color (Both Sides)</Table.HeaderCell>
                        <Table.HeaderCell><Icon name="edit" onClick={this.handleEditClicked.bind(this, variant.id)} /></Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      {
                        variant.prices.map((price, index) => (
                          <Table.Row key={index}>
                            <Table.Cell>
                              <Form.Field control="input" type="number" step="1" name="quantity" value={price.quantity} disabled={!variant.edit} onChange={this.handleTableInputChange.bind(this, variant.id, index)} />
                            </Table.Cell>
                            <Table.Cell>
                              <Form.Field control="input" type="number" step="0.01" name="4C_(Both)" value={price['4C_(Both)']} disabled={!variant.edit} onChange={this.handleTableInputChange.bind(this, variant.id, index)} />
                            </Table.Cell>
                            <Table.Cell collapsing>
                              <Icon name={(variant.edit) ? 'delete' : ''} color="red" onClick={this.handleRowDelete.bind(this, variant.id, index)} />
                            </Table.Cell>
                          </Table.Row>
                        ))
                      }
                      {(variant.add) &&
                        <Table.Row warning={!variant.error} error={variant.error}>
                          <Table.Cell>
                            <Form.Field control="input" type="number" step="1" name="quantity" value={variant.new.quantity} onChange={this.handleTableInputChange.bind(this, variant.id, -1)} />
                          </Table.Cell>
                          <Table.Cell>
                            <Form.Field control="input" type="number" step="0.01" name="4C_(Both)" value={variant.new['4C_(Both)']} onChange={this.handleTableInputChange.bind(this, variant.id, -1)} />
                          </Table.Cell>
                          <Table.Cell collapsing>
                            <Icon name="undo" onClick={this.handleResetRow.bind(this, variant.id)} />
                          </Table.Cell>
                        </Table.Row>
                      }
                    </Table.Body>
                    <Table.Footer fullWidth>
                      <Table.Row>
                        <Table.HeaderCell>
                          <Form.Field inline>
                            <label>Duration</label>
                            <input type="number" step="1" name="duration" value={variant.duration} disabled={!variant.edit} onChange={this.handleDurationInputChange.bind(this, variant.id)} />
                          </Form.Field>
                        </Table.HeaderCell>
                        <Table.HeaderCell colSpan="3">
                          {(variant.edit) &&
                            <Fragment>
                              <Button floated="right" icon labelPosition="left" primary size="small" disabled={!variant.edit} onClick={this.handleAddRow.bind(this, variant.id)}>
                                <Icon name="add" />Add
                                                            </Button>
                              <Button floated="right" icon labelPosition="left" primary size="small" disabled={!variant.edit} onClick={this.handleSaveClicked.bind(this, variant.id)}>
                                <Icon name="save" />Save
                                                            </Button>
                            </Fragment>
                          }
                        </Table.HeaderCell>
                      </Table.Row>
                    </Table.Footer>
                  </Table>
                </Form>
                : null
              }
            </Segment>
          </Segment.Group>
        ))
        }
      </Container>
    )
  }
}

const mapStateToProps = ({ product }) => {
  return { product };
}

const matchDispatchToProps = (dispatch) => {
  return bindActionCreators({
      hideLoading: hideLoading,
      addProductPricing: addProductPricing,
      getProductPricing: getProductPricing,
      getProductOptions: getProductOptions,
      updatePricingTable: updatePricingTable
  }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(Brochure)